// @ts-strict-ignore
import jwtDecode, { JwtPayload } from 'jwt-decode'

export function isJwtFresh(token: string) {
	const decoded = jwtDecode<JwtPayload>(token)

	if ('exp' in decoded) {
		const now = Date.now() / 1000 // current time in seconds
		return decoded.exp > now
	} else {
		return false
	}
}
